var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5441_45631",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5441_45631",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACNUlEQVRo3u2av07CQBzHHWQibPACLAwmMgCFUXcNgU0aSPANYEcHSHCEwSg+g8T3kD+GkT/GAV4BEpSkfn/JNTZQoEJpf2e85LP02rvP93ot5dqjo//yU6KPQx9IABUUQUlQFNuozsdGOPY4IOkIqIIuWABtC7TPG7gD0ejD0JWR9oA86FkQ3ga1cU1tOjDiQ5JPgZEN4stQm+lYY3SwUQ+AlwOIL0N9BOyWV8DEAXkd6itul/wFmDkor0N9XtohP3dBXudz5xBi2kxdlDeeCeW38n4wZiCvQy5+S/LK0zsFaDKS12lGGkNLo59kKK+T3CZ/DPqMAwzIcVOALGN5nZz5Y8L9BwVoSxCgE2n0VwOEzlLhk+yNdpK9ZU/oPB1eCRAMBstAk4SKWYCWRAFay/Je8CVRAHL1GgMoEsnrKMYAVxIGuDIGKEgYoGAMUJIwQOlPBZB+Ckl/EUt/G5X7h0zCR4lXs2ehikQByisBVFUN12o1rV6vs4YcM5nM6UoATdOIjsa/tMnVtKAiJ0GA7Nr/xKg8BgPG8n1y3LgygR2SjAMkt64LiWuhyVD+ee3cNwnhB2NG8uTi/9X6KA5QwIyB/JRcdlqhxoGXYO6iPPV9sdc7AhHCjTMx21veECIOJg7KT3aeNhtCBMCLA/LUh70v+ZZusWkwOoA4tZmyfKvcM4gH5EHPBvGeaOvwL7rXnJEIqIIuWFgQXoh9q+JYPh97QMYHEkAFRVASFMU2quPzsQeH8g3SiV9oagO2rAAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM16);
export default __webpack_public_path__ + "static/media/m16.fdc622806cf2930749220c86a75f4154.svg";
export { ForwardRef as ReactComponent };